import { useAuthenticatedMutation, useAuthenticatedQuery } from 'client/hooks';
import { useAppState } from 'client/providers/AppProvider';
import { DashboardFullPageLoading } from 'components/common/GenericFullPageLoading';
import {
    GetAllProfileViewDataForPlayersQuery,
    GetAllProfileViewDataForPlayersQueryVariables,
    GetAllProfileViewDataForPlayersDocument,
    UnfollowCollegeDocument,
    UnfollowCollegeMutation,
    UnfollowCollegeMutationVariables,
    FollowCollegeMutation,
    FollowCollegeMutationVariables,
    FollowCollegeDocument,
} from 'generated/spin-graphql';
import React, { useMemo } from 'react';
import { gql } from 'urql';
import { ProfileViews } from './ProfileViews';

gql`
    query GetAllProfileViewDataForPlayers($userId: String, $date: timestamptz) {
        espin_follow(where: { player_user_id: { _eq: $userId }, follow_type: { _eq: player_follows_college } }) {
            college_id
        }
        espin_profile_view(
            where: { player_user_id: { _eq: $userId }, profile_view_type: { _eq: college_views_player } }
            order_by: { created_at: desc }
        ) {
            ...ProfileViews
        }
        espin_profile_view_aggregate(
            where: {
                player_user_id: { _eq: $userId }
                profile_view_type: { _eq: college_views_player }
                created_at: { _gt: $date }
            }
        ) {
            aggregate {
                count
            }
        }
    }
`;
const backUpDate = new Date().toISOString();
const PlayerProfileViews = () => {
    const { user } = useAppState();

    const { isReady, data: playerData } = useAuthenticatedQuery<
        GetAllProfileViewDataForPlayersQuery,
        GetAllProfileViewDataForPlayersQueryVariables
    >(
        {
            query: GetAllProfileViewDataForPlayersDocument,
            variables: {
                userId: user?.id,
                date: user.last_login ?? backUpDate,
            },
            pause: !user.id,
        },
        ['espin_follow', 'espin_profile_view'],
    );
    // i don't like just importing these as shared mutations...
    const [_, unFollowCollege] = useAuthenticatedMutation<UnfollowCollegeMutation, UnfollowCollegeMutationVariables>(
        UnfollowCollegeDocument,
    );

    const [__, followCollege] = useAuthenticatedMutation<FollowCollegeMutation, FollowCollegeMutationVariables>(
        FollowCollegeDocument,
    );

    const onUnfollow = useMemo(() => {
        return (idToUnfollow: string) => {
            unFollowCollege(
                { collegeId: idToUnfollow, playerUserId: user?.id },
                { additionalTypenames: ['espin_follow'] },
            );
        };
    }, [unFollowCollege, user?.id]);
    const onFollow = useMemo(() => {
        return (idToFollow: string) => {
            followCollege({ collegeId: idToFollow }, { additionalTypenames: ['espin_follow'] });
        };
    }, [followCollege]);

    const listOfFollows = useMemo(() => playerData?.espin_follow.map((m) => m.college_id), [playerData?.espin_follow]);
    if (!!!user) {
        return <DashboardFullPageLoading />;
    }

    return (
        <div>
            {isReady && (
                <ProfileViews
                    listOfFollows={listOfFollows}
                    profileViews={playerData.espin_profile_view}
                    totalViews={playerData?.espin_profile_view.length}
                    newViews={playerData.espin_profile_view_aggregate.aggregate.count}
                    onFollow={onFollow}
                    onUnfollow={onUnfollow}
                />
            )}
        </div>
    );
};

export default PlayerProfileViews;
